import { Component, OnInit } from '@angular/core';
import { AgentBankBranchSearchHandler } from './agent-bank-branch-search.handler';
import { AgentService } from '../services/agent.service';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { Router } from '@angular/router';
import { SettingService } from 'src/app/system-common/services/setting.service';

@Component({
  selector: 'sym-agent-bank-branch-search',
  templateUrl: './agent-bank-branch-search.component.html',
  styleUrls: ['./agent-bank-branch-search.component.scss'],
})
export class AgentBankBranchSearchComponent extends AgentBankBranchSearchHandler {
  constructor(
    public service: AgentService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService
  ) {
    super(service, headerService, router, settingService);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
